var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-main',[_c('div',{staticClass:"top-wrap"},[_c('Bread')],1),_c('div',{staticClass:"main"},[(_vm.id)?_c('DetailTopPart',{attrs:{"orderId":_vm.id}}):_vm._e(),(_vm.id)?_c('OrderSettlement',{attrs:{"orderId":_vm.id}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }